import { createFileRoute } from "@tanstack/react-router";
import { FormAnalyticsPage } from "@/features/forms/FormAnalyticsPage";

export const Route = createFileRoute("/_app/forms/$form/analytics")({
  component: Page,
});

function Page() {
  const { form } = Route.useParams();
  return <FormAnalyticsPage slug={form} />;
}
